import * as OfferingTypes from 'marketplace-ui-common/offerings/constants/OfferingType';
import * as ReviewTypes from './ReviewType';
export const OfferingReviewType = {
  [OfferingTypes.MODULE]: ReviewTypes.MODULE,
  [OfferingTypes.THEME]: ReviewTypes.THEME,
  [OfferingTypes.APP]: ReviewTypes.APP
};